import React, { useEffect, useState } from 'react';

/* Common */
import CardArticle from '../../common/cards/CardArticle';

/* Components */
import ArticleFilter from './ArticleFilter';

export default function ArticleOverview({content, articles}) {
    const [filteredArticles, setFilteredArticles] = useState(articles);

    useEffect(() => {
        const articleConent = document.querySelector('[data-article-content]');
        if (articleConent) articleConent.remove();
    });

    return (
        <div className="row row--equalized gutters-2 gutters-lg-4">
            <ArticleFilter setFilteredArticles={setFilteredArticles} articles={articles} />
            {filteredArticles && filteredArticles.map((article, index) => (
                <CardArticle key={index} imgUrl={article.imgUrl} imgTitle={article.imgTitle} title={article.title} subtitle={article.description} url={article.url} theme={content?.link_theme} />
            ))}
        </div>
    )
}
